<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">账号：</label>
        <el-input class="input-box" placeholder="操作账号" v-model="queryParams.account" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName">日期：</label>
        <el-date-picker v-model="queryParams.dateRange" type="daterange" value-format="yyyy-MM-dd"
          start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false"></el-date-picker>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="account" label="账号" width="130" align="center"></el-table-column>
      <el-table-column prop="modelName" label="模块" width="140" align="center"></el-table-column>
      <el-table-column prop="opratorType" label="操作类型" width="110" align="center"></el-table-column>
      <el-table-column prop="result" label="结果" min-width="220" align="center"></el-table-column>
      <el-table-column prop="ip" label="IP" width="140" align="center"></el-table-column>
      <el-table-column prop="createTime" label="时间" width="170" align="center"></el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

function formatDay(date) {
  const y = date.getFullYear()
  const m = date.getMonth() + 1
  const d = date.getDate()
  return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
}

function defaultRange() {
  const end = new Date()
  const begin = new Date()
  begin.setDate(begin.getDate() - 6)
  return [formatDay(begin), formatDay(end)]
}

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      queryParams: { pageIndex: 1, pageSize: 10, account: '', dateRange: defaultRange() },
      tableData: []
    }
  },
  created() { this.GetData() },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    GetData() {
      const range = this.queryParams.dateRange || defaultRange()
      const loading = this.openLoading()
      post(401, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        account: (this.queryParams.account || '').trim(),
        beginTime: range[0] || '',
        endTime: range[1] || ''
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    }
  }
}
</script>
